import type {
  SandboxAdminUser,
  SignupListMutationVariables,
  SignupListsResponse,
  UserStatusUpdate,
} from "shell/console/types";

import { useSandboxAdminMutation } from "./useSandboxAdminApi";

export const useUpdateSandboxAdminUserStatus = () =>
  useSandboxAdminMutation<
    SandboxAdminUser,
    { user_id: string } & UserStatusUpdate
  >(({ user_id }) => `/users/${user_id}/status`, { method: "PATCH" });

export const useAddSandboxSignupDomain = () =>
  useSandboxAdminMutation<SignupListsResponse, SignupListMutationVariables>(
    ({ list }) => `/admin/signup-lists/${list}`,
    {
      method: "POST",
      getBody: ({ entry }) => ({ entry }),
    },
  );

export const useRemoveSandboxSignupDomain = () =>
  useSandboxAdminMutation<SignupListsResponse, SignupListMutationVariables>(
    ({ list, entry }) =>
      `/admin/signup-lists/${list}/${encodeURIComponent(entry)}`,
    { method: "DELETE", getBody: () => undefined },
  );
